import React, { useEffect, useState } from "react";
import { toast } from "sonner";
import AdminLayout from "../../components/admin/AdminLayout";
import { MagnifyingGlass, QrCode, Gift } from "@phosphor-icons/react";

export default function AdminActivity() {
  const [results, setResults] = useState([]);
  const [filters, setFilters] = useState({ code: "", session_id: "", outlet_id: "" });
  const [loading, setLoading] = useState(false);

  async function search() {
    setLoading(true);
    try {
      const qs = new URLSearchParams();
      if (filters.code) qs.set("code", filters.code);
      if (filters.session_id) qs.set("session_id", filters.session_id);
      if (filters.outlet_id) qs.set("outlet_id", filters.outlet_id);
      qs.set("limit", "50");
      
      const res = await fetch(`${process.env.REACT_APP_BACKEND_URL}/api/admin/activity?${qs}`, {
        headers: { Authorization: `Bearer ${localStorage.getItem("rs_token")}` },
      });
      if (!res.ok) throw new Error("Search failed");
      setResults(await res.json());
    } catch (e) {
      toast.error(e.message);
    } finally {
      setLoading(false);
    }
  }

  // eslint-disable-next-line react-hooks/exhaustive-deps
  useEffect(() => { search(); }, []);

  return (
    <AdminLayout>
      <div className="space-y-4">
        <div className="card-pop p-4">
          <h3 className="font-bold mb-3">Search Filters</h3>
          <div className="grid sm:grid-cols-3 gap-3">
            <input placeholder="Reward Code" className="input-pop" value={filters.code} onChange={e => setFilters({...filters, code: e.target.value})} />
            <input placeholder="Session ID" className="input-pop" value={filters.session_id} onChange={e => setFilters({...filters, session_id: e.target.value})} />
            <input placeholder="Outlet ID" className="input-pop" value={filters.outlet_id} onChange={e => setFilters({...filters, outlet_id: e.target.value})} />
          </div>
          <button onClick={search} className="btn-primary mt-3 text-sm">Search</button>
        </div>

        <div className="card-pop overflow-x-auto">
          <table className="w-full text-sm">
            <thead>
              <tr className="border-b-2" style={{ borderColor: "var(--border)" }}>
                <th className="py-2 px-3 text-left font-bold">Type</th>
                <th className="py-2 px-3 text-left font-bold">Time</th>
                <th className="py-2 px-3 text-left font-bold">Outlet</th>
                <th className="py-2 px-3 text-left font-bold">Details</th>
              </tr>
            </thead>
            <tbody>
              {loading && <tr><td colSpan={4} className="py-8 text-center text-[var(--ink-muted)]">Searching...</td></tr>}
              {!loading && results.length === 0 && <tr><td colSpan={4} className="py-8 text-center text-[var(--ink-muted)]">No results</td></tr>}
              {results.map((r, i) => (
                <tr key={i} className="border-b hover:bg-gray-50" style={{ borderColor: "var(--border)" }}>
                  <td className="py-2 px-3">
                    {r.event_type === "scan" ? (
                      <span className="inline-flex items-center gap-1 text-xs font-bold px-2 py-0.5 rounded-full bg-blue-100 text-blue-700">
                        <QrCode size={10} /> Scan
                      </span>
                    ) : (
                      <span className="inline-flex items-center gap-1 text-xs font-bold px-2 py-0.5 rounded-full bg-orange-100 text-orange-700">
                        <Gift size={10} /> Spin
                      </span>
                    )}
                  </td>
                  <td className="py-2 px-3">{new Date(r.created_at).toLocaleString()}</td>
                  <td className="py-2 px-3">{r.outlets?.name || "-"}</td>
                  <td className="py-2 px-3">
                    {r.event_type === "spin_attempt" ? (
                      <span>{r.reward_label} · Code: <span className="font-mono text-xs">{r.redemption_code || "-"}</span> · {r.redeemed ? "Redeemed" : "Pending"}</span>
                    ) : (
                      <span className="text-xs text-[var(--ink-muted)]">Session: {r.session_id?.slice(0, 8)}...</span>
                    )}
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </div>
    </AdminLayout>
  );
}